export default __webpack_public_path__ + "static/media/pvilla4-1.c600ca7a.jpg";